<div class="order-edit-delivery">
  <form class="deliveryForm row" [formGroup]="deliveryForm" *ngIf="panelStatus.isEdit">

    <ng-container *ngIf="!panelStatus.isNew && relocationDetail.etmOrderNumber">
      <eps-label-body label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER" [labelWidth]="labelWidth">
        {{ relocationDetail.etmOrderNumber }}
      </eps-label-body>
      <eps-label-body label="ORDERS.FILTER.LABELS.ETM_SHIPPING_NUMBER" [labelWidth]="labelWidth">
        {{ getETMShipmentNumbersAsString(relocationDetail.shipmentNumbers) }}
      </eps-label-body>
    </ng-container>

    <!-- FROM : select -->
    <eps-select
      [options]="locations"
      formControlName="from"
      label="ORDERS.DELIVERY.LABELS.FROM"
      [labelWidth]="labelWidth"
      [bindAsObject]="true"
      autoSelect
    ></eps-select>

    <!-- TO : select -->
    <eps-select
      [options]="locations"
      formControlName="to"
      label="ORDERS.DELIVERY.LABELS.TO"
      [labelWidth]="labelWidth"
      [bindAsObject]="true"
      autoSelect
    ></eps-select>

    <!-- CUSTOMER REFERENCE NUMBER : text -->
    <eps-text-input
      [labelWidth]="labelWidth"
      label="ORDERS.DELIVERY.LABELS.CUSTOMER_REFERENCE_NUMBER"
      formControlName="customerReferenceNumber"
      [maxLength]="35"
    ></eps-text-input>

    <!-- LICENCE PLATE : text -->
    <eps-text-input
      [labelWidth]="labelWidth"
      label="ORDERS.DELIVERY.LABELS.LICENCE_PLATE"
      formControlName="licensePlate"
      [maxLength]="15"
    ></eps-text-input>

    <div class="row empty">
      <div class="col-12 hr-thick"></div>
    </div>

    <div class="buttons">
      <eps-button
        type="link"
        (buttonClick)="cancelClicked.emit()"
        label="SHARED.BUTTONS.CANCEL"
        *ngIf="panelStatus.isNew"
        minWidth="10px"
      ></eps-button>
      <eps-button
        buttonIcon="check"
        [busy]="deliveryForm.pending"
        [disabled]="deliveryForm.pending || !deliveryForm.valid"
        (buttonClick)="doNextClicked()"
        [label]="panelStatus.isNew ? 'ORDERS.DELIVERY.BUTTONS.NEXT' : 'ORDERS.DELIVERY.BUTTONS.SAVE'"
        submit
      ></eps-button>
    </div>
  </form>

  <!--
  http://patorjk.com/software/taag/#p=display&c=c%2B%2B&f=Big&t=Read%20only%20version
    _____                _               _                            _
   |  __ \              | |             | |                          (_)
   | |__) |___  __ _  __| |   ___  _ __ | |_   _  __   _____ _ __ ___ _  ___  _ __
   |  _  // _ \/ _` |/ _` |  / _ \| '_ \| | | | | \ \ / / _ \ '__/ __| |/ _ \| '_ \
   | | \ \  __/ (_| | (_| | | (_) | | | | | |_| |  \ V /  __/ |  \__ \ | (_) | | | |
   |_|  \_\___|\__,_|\__,_|  \___/|_| |_|_|\__, |   \_/ \___|_|  |___/_|\___/|_| |_|
                                            __/ |
                                           |___/
  -->
  <!--Form displayed when detail is opend  -->
  <form class="deliveryForm desktop-only" [formGroup]="deliveryForm" *ngIf="!panelStatus.isEdit">
    <div class='row align_top' *ngIf='!panelStatus.isNew && relocationDetail.etmOrderNumber'>
      <div class='row col-12 col-sm-6 col-xs-wrapper'>
        <div class='col-12 col-md-4 form-label'>
          <app-label translationCode='ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER'></app-label>
        </div>
        <div class='col-12 col-md-8'>
          {{ relocationDetail.etmOrderNumber }}
        </div>
      </div>
      <div class='row col-12 col-sm-6 col-xs-wrapper'>
        <div class='col-12 col-md-4 form-label'>
          <app-label translationCode='ORDERS.FILTER.LABELS.ETM_SHIPPING_NUMBER'></app-label>
        </div>
        <div class='col-12 col-md-8'>
          {{ getETMShipmentNumbersAsString(relocationDetail.shipmentNumbers) }}
        </div>
      </div>
    </div>

    <div class="row align_top" *ngIf="relocationDetail.salesOrderNumber">
      <div class="row col-12 col-sm-6 col-xs-wrapper">
        <div class="col-12 col-md-4 form-label">
          <app-label translationCode="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER"></app-label>
        </div>
        <div class="col-12 col-md-8">
          {{ relocationDetail.salesOrderNumber }}
        </div>
      </div>
    </div>

    <!-- arrow header -->
    <div class="three-lines align_top">
      <div class="row col-12 col-md-6 col-xs-wrapper">
        <div class="col-12 col-md-4 form-label">
          <app-label translationCode="ORDERS.DELIVERY.LABELS.FROM"></app-label>
        </div>
        <div class="col-12 col-md-6">
          {{ deliveryForm.value.from?.name }}
        </div>
        <div class="col-md-2 show-from-md">
          <app-arrow class="myarrow" [width]="60"></app-arrow>
        </div>
      </div>
      <div class="row col-12 col-md-6 col-xs-wrapper">
        <div class="col-12 col-md-4 form-label">
          <app-label translationCode="ORDERS.DELIVERY.LABELS.TO"></app-label>
        </div>
        <div class="col-12 col-md-8">
          {{ deliveryForm.value.to?.name }}
        </div>
      </div>
    </div>
    <!--end of arrow header  -->

    <div class="hr"></div>

    <div class="row align_top">
      <div class="row col-12 col-sm-6 col-xs-wrapper">
        <div class="col-12 col-md-4 form-label">
          <app-label translationCode="ORDERS.DELIVERY.LABELS.CUSTOMER_REF"></app-label>
        </div>
        <div class="col-12 col-md-8">
          {{ deliveryMethod?.customerReferenceNumber || '' }}
        </div>
      </div>
      <div class="row col-12 col-sm-6 col-xs-wrapper">
        <div class="col-12 col-md-4 form-label">
          <app-label translationCode="ORDERS.DELIVERY.LABELS.PLATE"></app-label>
        </div>
        <div class="col-12 col-md-8">
          {{ deliveryMethod?.licensePlate ? deliveryMethod?.licensePlate : ('ORDERS.DELIVERY.LABELS.NO_LICENCE_PLATE' | translate) }}
        </div>
      </div>
    </div>
  </form>
</div>
